import { render, staticRenderFns } from "./noticerelname.vue?vue&type=template&id=161ff5d1&scoped=true"
import script from "./noticerelname.vue?vue&type=script&lang=js"
export * from "./noticerelname.vue?vue&type=script&lang=js"
import style0 from "./noticerelname.vue?vue&type=style&index=0&id=161ff5d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161ff5d1",
  null
  
)

export default component.exports